import { queryOptions } from '@tanstack/react-query';
import type { User } from '../model/schema';
import { userApi } from './user-api';

export const userKeys = {
  all: ['user'] as const,
  list: () => [...userKeys.all, 'list'] as const,
  detail: (id: User['id']) => [...userKeys.all, 'detail', id] as const,
  locations: () => [...userKeys.all, 'locations'] as const,
  employeeLocations: (id: string) => [...userKeys.all, 'employee-locations', id] as const,
};

export const userQueries = {
  list: () =>
    queryOptions({
      queryKey: userKeys.list(),
      queryFn: ({ signal }) => userApi.list({ signal }),
    }),

  /**
   * One member by id, for the edit form's seed. `staleTime: 0` and re-seeding
   * on `dataUpdatedAt` — the rule CLAUDE.md §8 "Edit forms" sets out, so
   * reopening a form never replays a pre-edit copy from cache.
   */
  detail: (id: User['id']) =>
    queryOptions({
      queryKey: userKeys.detail(id),
      queryFn: ({ signal }) => userApi.get(id, { signal }),
      staleTime: 0,
    }),
  locations: () =>
    queryOptions({
      queryKey: userKeys.locations(),
      queryFn: () => userApi.locations(),
      staleTime: 300000,
    }),
  employeeLocations: (id: string) =>
    queryOptions({
      queryKey: userKeys.employeeLocations(id),
      queryFn: () => userApi.employeeLocations(id),
      enabled: Boolean(id),
    }),
};
